import { FormControl, Validators } from '@angular/forms';
const notEmptyTrimmed = (c: FormControl) =>
  c.value && c.value.trim && c.value.trim().length > 0 ? null : { required: true };

export const version = {
  name: Validators.compose([Validators.required, Validators.minLength(1), Validators.maxLength(50), notEmptyTrimmed])
};
